import { FC, useMemo } from 'react'
import {
  Datagrid, DateField, FunctionField, List, SelectInput, TextField, useTranslate,
} from 'react-admin'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import { SeverityChip } from '../../components'
import { xxllncColor } from '../../layout/theme/color'
import { MonitoringAlertOut } from '../../types/apiRequests'

const MonitoringAlertList: FC = () => {
  const translate = useTranslate()

  const alertFilters = useMemo(() => [
    <SelectInput
      key="severity"
      source="severity"
      choices={[
        { id: 'critical', name: translate('data.severityCritical') },
        { id: 'warning', name: translate('data.severityWarning') },
        { id: 'info', name: translate('data.severityInfo') },
      ]}
      alwaysOn
    />,
    <SelectInput
      key="acknowledged"
      source="acknowledged"
      choices={[
        { id: 'true', name: translate('ra.boolean.true') },
        { id: 'false', name: translate('ra.boolean.false') },
      ]}
      alwaysOn
    />,
  ], [translate])

  return (
    <List
      exporter={false}
      sort={{ field: 'created', order: 'DESC' }}
      filters={alertFilters}
    >
      <Datagrid bulkActionButtons={false} rowClick="show">
        <FunctionField<MonitoringAlertOut>
          label="data.severity"
          render={(record) => <SeverityChip severity={record.severity} />}
        />
        <TextField source="message" />
        <TextField source="rule_display_name" label="resources.monitoring_rule.name" />
        <TextField source="organization_display_name" label="data.organization" />
        <FunctionField<MonitoringAlertOut>
          label="data.acknowledged"
          render={(record) =>
            record.acknowledged ? <CheckCircleIcon fontSize="small" sx={{ color: xxllncColor.green100 }} /> : null
          }
        />
        <DateField source="created" showTime label="data.createdAt" />
      </Datagrid>
    </List>
  )
}

export default MonitoringAlertList
